import { makeStyles } from '@cuda-networks/bds-core'

export default makeStyles(() => ({
  styledTabs: {
    textTransform: 'uppercase'
  }
}))
